import * as Sentry from "@sentry/react";
import JwtDecode from "jwt-decode";
import { useSearchParams } from "react-router-dom";

const useToken = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token")!;
    const { ...decoded } = decode(token);
    const viewOnly = decoded.aud === "assessment-view";

    setSentryContext(decoded);

    return { token, decoded, viewOnly };
};

const setSentryContext = (decoded: JwtToken) => {
    const tags: Record<string, string> = {};
    if (decoded.tenant) tags.tenant = decoded.tenant;
    if (decoded.campaignId) tags.campaignId = decoded.campaignId;
    if (decoded.questionnaireId) tags.questionnaireId = decoded.questionnaireId;
    if (decoded.supplierId) tags.supplierId = decoded.supplierId;
    if (decoded.customerName) tags.customerName = decoded.customerName;
    if (decoded.assessmentIds?.length) tags.assessmentIds = decoded.assessmentIds.join(",");
    Sentry.setTags(tags);

    if (decoded.supplierId || decoded.receiverEmail) {
        Sentry.setUser({ id: decoded.supplierId, email: decoded.receiverEmail });
    }
};

/* eslint-disable-next-line camelcase */
type JwtToken = {
    aud?: string;
    campaignId?: string;
    tenant?: string;
    assessmentIds?: string[];
    customerName?: string;
    receiverEmail?: string;
    supplierId?: string;
    questionnaireId?: string;
    requesterName?: string;
    requesterEmail?: string;
    targetLanguage?: string;
};

const decode = (token: string | null | undefined): JwtToken => {
    if (!token) return {};
    try {
        return JwtDecode<JwtToken>(token);
    } catch {
        return {};
    }
};

export default useToken;
